import { LoadablePaint } from '@confluence/loadable';

export const ChangeHistoryMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ChangeHistoryMacro" */ '../src/ChangeHistoryMacroRenderer.tsx'
			)
		).ChangeHistoryMacroRenderer,
});
